import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import {
  default as CheckCircleIcon,
  default as SvgIcon,
} from "@mui/icons-material/CheckCircle";
import DangerousIcon from "@mui/icons-material/Dangerous";
import StarIcon from "@mui/icons-material/Star";
import Tooltip from "@mui/material/Tooltip";
import "../../../../Tooltip/styles/tooltip.css";
import "./styles/color-legend.css";

const ColorsLegend = ({ requestStatus }) => {
  const baseColors = {
    Completed: "rgb(7, 244, 31)",
    Incomplete: "rgb(224, 12, 12)",
    Current: "rgb(36, 182, 255)",
  };

  const baseIcons = {
    Completed: CheckCircleIcon,
    Incomplete: DangerousIcon,
    Current: StarIcon,
  };

  const revisionColors = {
    Completed: "rgb(7, 244, 31)",
    Revisions: "rgb(255, 102, 20)",
    // Revised: "rgb(228, 144, 7)",
    Current: "rgb(36, 182, 255)",
  };

  const revisionIcons = {
    Completed: CheckCircleIcon,
    Revisions: AssignmentLateIcon,
    // Revised: AssignmentLateIcon,
    Current: StarIcon,
  };

  const baseColorIds = {
    Completed: "completed-dot",
    Incomplete: "incomplete-dot",
    Current: "current-slide-dot",
  };

  const revisionColorIds = {
    Revisions: "revisions-dot",
    // Revised: "revised-dot",
    Completed: "completed-dot",
    Current: "current-slide-dot",
  };

  const colorsMessage = {
    Completed: "All required fields have been filled out for this slide",
    Incomplete: "Required fields have not been filled out for this slide",
    Revisions:
      "The incomplete/invalid fields for this slide have not been updated",
    Current: "This is the current page",
  };
  return (
    <div className="colors-legend-container">
      {requestStatus !== "RV" ? (
        <div className="colors-legend">
          {Object.keys(baseColors).map((key, index) => {
            return (
              <Tooltip
                key={`${key}-tooltip`}
                id="color-legend-tooltip"
                title={colorsMessage[key]}
                placement={
                  key === "Incomplete" || key === "Completed" ? "top" : "bottom"
                }
                arrow
                classes={{
                  tooltip: "color-legend-tooltip",
                  popper: "color-legend-popper",
                  arrow: "color-legend-arrow",
                  tooltipPlacementTop: "tooltip-top",
                  tooltipPlacementBottom: "tooltip-bottom",
                }}
              >
                <div id={baseColorIds[key]} className="colors" key={index}>
                  <span
                    className={"color-label"}
                    id={`label-${key}`}
                  >{`${key === "Current" ? "Current Page" : key}: `}</span>
                  <SvgIcon
                    className="legend-icon"
                    id={`icon-${key}`}
                    component={baseIcons[key]}
                  />
                </div>
              </Tooltip>
            );
          })}
        </div>
      ) : (
        <div className="colors-legend revise">
          {Object.keys(revisionColors).map((key, index) => {
            return (
              <Tooltip
                key={`${key}-tooltip`}
                title={colorsMessage[key]}
                placement={key !== "Current" ? "top" : "bottom"}
                arrow
                id="color-legend-tooltip"
                classes={{
                  tooltip: "color-legend-tooltip",
                  popper: "color-legend-popper",
                  arrow: "color-legend-arrow",
                  tooltipPlacementTop: "tooltip-top",
                  tooltipPlacementBottom: "tooltip-bottom",
                }}
              >
                <div
                  id={revisionColorIds[key]}
                  className={"colors"}
                  key={index}
                >
                  <span className={"color-label"} id={`label-${key}`}>{`${
                    key === "Current" ? "Current Page" : key
                  }: `}</span>
                  <SvgIcon
                    className="legend-icon"
                    id={`icon-${key}`}
                    component={revisionIcons[key]}
                  />
                </div>
              </Tooltip>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ColorsLegend;
